var React = require('react');

function IconX (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"X icon"),React.createElement("desc",{"key":1},"X icon"),React.createElement("g",{"fill":"none","fillRule":"evenodd","stroke":"#424242","key":2},React.createElement("path",{"d":"M8.22.507L.508 8.22M8.22 8.22L.508.508"}))]);
}

IconX.defaultProps = {"width":"9","height":"9","viewBox":"0 0 9 9","role":"img"};

module.exports = IconX;

IconX.default = IconX;
